//-------------------------------------------------------------------------------------------------- Imports
import { Card, Skeleton } from "antd";
import { StyleSheet } from "../../StyleSheet";
import { useCallback, useEffect, useState } from "react";
import _ from "lodash";
import { getLastPayments } from "../../methods/Methods";
import { ResponseListadoPagosGralData } from "../../types/common";
import SubDefaultLayout from "../../components/SubDefaultLayout";
import InfoCardComponent from "../../components/InfoCardComponent";
import { useSelector } from "react-redux";
import { getGeneralData } from "../../stores/slices/generalDataSlice";

//-------------------------------------------------------------------------------------------------- View
const LastPayments = () => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [listPayments, setListPayments] = useState<Array<ResponseListadoPagosGralData>>([]);
    const [hasError, setHasError] = useState(false);
    const [message, setMessage] = useState("");
    const generalData = useSelector(getGeneralData);
    const [clientId, setClientId] = useState<string>("");

    const getData = useCallback(async () => {
        setIsLoading(true);
        await getLastPayments(clientId)
            .then((response) => {
                if (response.data.data[0].data) {
                    if (_.isEmpty(response.data.data[0].data)) {
                        setMessage("No hay información para mostrar.");
                    } else {
                        setListPayments(response.data.data[0].data);
                    }
                }
                setIsLoading(false);
            })
            .catch(() => {
                setHasError(true);
                setMessage("Hubo un error al procesar su solicitud. \nIntente más tarde.");
                setIsLoading(false);
            })
    }, [clientId]);

    useEffect(() => {
        if (generalData.selectedContract !== null) {
            setClientId(
                generalData.selectedContract.sucursal + generalData.selectedContract.suscriptor
            );
        }
    }, [generalData.selectedContract]);

    useEffect(() => {
        if (clientId && !_.isEmpty(clientId)) {
            getData();
        }
    }, [clientId, getData]);

    return (
        <SubDefaultLayout
            title={"Últimos Pagos"}
            needReturn={true}
            navigateTo={"/payments"}
        >
            {
                isLoading ?
                    <Card style={styles.card}>
                        <Skeleton style={styles.container} />
                    </Card>
                    :
                    !_.isEmpty(listPayments) && !hasError ?
                        <Card style={styles.card}>
                            <table style={styles.table}>
                                <thead>
                                    <tr>
                                        <th style={{ ...styles.titleTable, borderTopLeftRadius: 25, borderBottomLeftRadius: 25 }}>
                                            {"Folio"}
                                        </th>
                                        <th style={styles.titleTable}>
                                            {"Fecha"}
                                        </th>
                                        <th style={styles.titleTable}>
                                            {"Realizado Desde:"}
                                        </th>
                                        <th style={{ ...styles.titleTable, borderTopRightRadius: 25, borderBottomRightRadius: 25 }}>
                                            {"Monto"}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        listPayments.map((element: any, index: any) => (
                                            <tr key={index} style={styles.tableDataRow}>
                                                <td style={styles.textContainFolio}>
                                                    {element.folio}
                                                </td>
                                                <td style={styles.textContainOthers}>
                                                    {element.fecha}
                                                </td>
                                                <td style={styles.textContainOthers}>
                                                    {element.origen}
                                                </td>
                                                <td style={styles.textContainMonto}>
                                                    {`$${element.monto}`}
                                                </td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </Card>
                        :
                        <InfoCardComponent
                            title="¡Estimado Usuario!"
                            description={message}
                        />
            }
        </SubDefaultLayout>
    );
};

//-------------------------------------------------------------------------------------------------- Styles
const styles = StyleSheet.create({
    card: {
        borderRadius: 20,
        boxShadow: "0px 0px 8px #00000029",
    },
    container: {
        width: "100%",
    },
    table: {
        width: "100%",
        borderCollapse: "collapse",
        borderSpacing: 0,
        overflow: 'hidden',
    },
    titleTable: {
        backgroundColor: "#0055c2",
        fontSize: 13,
        color: 'white',
        textAlign: "center",
        padding: "5px 10px",
    },
    tableDataRow: {
        borderBottom: "1px solid #000000",
    },
    textContainOthers: {
        fontSize: 12,
        color: "#646567",
        textAlign: "center",
        paddingTop: 20,
        paddingBottom: 20
    },
    textContainMonto: {
        fontSize: 12,
        color: "#646567",
        textAlign: "center",
        paddingTop: 20,
        paddingBottom: 20
    },
    textContainFolio: {
        fontSize: 12,
        textAlign: "center",
        color: "#000000",
        paddingTop: 20,
        paddingBottom: 20
    },
});

//-------------------------------------------------------------------------------------------------- Exports
export default LastPayments;
